import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';

export default function PFInputSwitch(props) {
  return <InputSwitch {...props} />;
}
